import React from "react";
import classnames from "classnames";
import map from "lodash/map";
import forEach from "lodash/forEach";
import { connect } from "react-redux";
import * as actions from "../../actions/actions";
import StripeCardElement from "../stripe-card-element";
import ToolTip from "../tool-tip";
import { constToCSS } from "../../reducers/download";

class IconPaymentForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.handleCardComplete = this.handleCardComplete.bind(this);
        this.handleSaveCardChange = this.handleSaveCardChange.bind(this);
        this.handleBillingInfoChange = this.handleBillingInfoChange.bind(this);
        this.doDownload = this.doDownload.bind(this);
    }
    componentDidMount() {
        if (
            this.props.user &&
            !this.props.user.is_anonymous &&
            this.props.user.has_credit_card
        ) {
            this.props.stripeGetSavedCard();
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.stripeError) {
            this.setState({
                stripeApi: null
            });
        }
    }
    handleCardComplete(stripeApi) {
        this.setState({
            stripeApi
        });
    }
    handleSaveCardChange(evt) {
        const { target } = evt;
        const value =
            target.type === "checkbox" ? target.checked : target.value;
        this.props.stripeSaveCardChange(value);
    }
    handleBillingInfoChange(evt) {
        const { target } = evt;
        const value =
            target.type === "checkbox" ? target.checked : target.value;
        this.props.stripeUpdateBillingInfo(value);
    }
    doDownload() {
        this.props.downloadPurchase(this.state.stripeApi);
    }
    canDownload() {
        let noCardCanDownload =
            (!this.props.savedCard || this.props.useNewCard) &&
            !!this.state.stripeApi;
        let savedCardCanDownload =
            !!this.props.savedCard && !this.props.useNewCard;
        return (
            !!this.props.currentPurchase &&
            (noCardCanDownload || savedCardCanDownload)
        );
    }
    render() {
        let {
            currentPurchase,
            purchaseTypes,
            saveCard,
            savedCard,
            useNewCard,
            showBillingInfo,
            billingInfo,
            processing
        } = this.props;

        let paymentOptions = { subscriptions: [], alacarte: [] };
        forEach(purchaseTypes, purchaseType => {
            let current =
                currentPurchase && purchaseType.key == currentPurchase.key;
            let optionClass = classnames(
                {
                    current
                },
                "bubble-choice",
                `purchase-${constToCSS(purchaseType.key)}`
            );
            let { period, price } = purchaseType;

            let text =
                purchaseType.text ||
                `${purchaseType.type}, ${purchaseType.period}`;

            let bestValue;

            let priceDispay = `$${price}`;
            let periodDisplay = (
                <div className="pro-info">
                    {period ? "billed " : ""} {period ? period : "each"}
                </div>
            );

            if (period == "yearly") {
                bestValue = <div className="pro-blue pro-info">best value</div>;
            }
            let component = (
                <li
                    className={optionClass}
                    key={purchaseType.key}
                    onClick={this.props.downloadSelectPurchaseType.bind(
                        null,
                        purchaseType.key
                    )}
                >
                    <span className="plan-text">
                        {text}
                        {bestValue}
                    </span>
                    <span className="plan-price">
                        {priceDispay}
                        {periodDisplay}
                    </span>
                </li>
            );
            if (period) {
                component = (
                    <ToolTip
                        key={purchaseType.key}
                        target={component}
                        position="right"
                        theme="light"
                    >
                        <NounProInfo />
                    </ToolTip>
                );
            }

            if (period) {
                paymentOptions.subscriptions.push(component);
            } else {
                paymentOptions.alacarte.push(component);
            }
        });

        let buttonClass = classnames("button", {
            blue: this.canDownload() && !processing,
            processing
        });

        let { stripeError } = this.props;
        let error;
        if (stripeError) {
            error = <div className="error stripe-error">{stripeError}</div>;
        }
        let noSavedCard = !savedCard;
        let usingSavedCard = !!savedCard && !useNewCard;
        let changingSavedCard = savedCard && useNewCard;

        let saveCardInput;
        let whatToPurchase = "Icon";
        if (currentPurchase) {
            if (!currentPurchase.period) {
                if (noSavedCard || changingSavedCard) {
                    let verb = changingSavedCard ? "Replace" : "Save";
                    saveCardInput = (
                        <div className="save-card-section">
                            <label htmlFor="save_card">{verb} card</label>
                            <div className="fancy-checkbox blue">
                                <input
                                    id="save_card"
                                    name="save_card"
                                    type="checkbox"
                                    checked={saveCard}
                                    onChange={this.handleSaveCardChange}
                                />
                                <label htmlFor="save_card" />
                            </div>
                        </div>
                    );
                }
            } else {
                whatToPurchase = "Subscription";
            }
        }

        let cardDisplay;
        if (!savedCard || useNewCard) {
            cardDisplay = (
                <StripeCardElement
                    stripePublishableKey={this.props.stripePublishableKey}
                    handleComplete={this.handleCardComplete}
                    handleChange={this.props.stripeCardInputChange}
                    handleError={this.props.stripeCardInputError}
                />
            );
        } else {
            cardDisplay = (
                <div className="saved-card">
                    <div className="card-number">
                        {savedCard.card_number.replace(/\*/g, "•")}
                    </div>
                    <div className="card-expiration">
                        {savedCard.card_expiration}
                    </div>
                    <div className="card-cvc">
                        {savedCard.card_cvc.replace(/\*/g, "•")}
                    </div>
                </div>
            );
        }

        let dueNow;
        if (currentPurchase) {
            dueNow = (
                <div className="purchase-total">
                    Due today <span>${currentPurchase.price}</span>
                </div>
            );
        }

        let savedCardAction;
        if (useNewCard && savedCard) {
            savedCardAction = (
                <div
                    className="link-action saved-card-action"
                    onClick={this.props.stripeUseNewCard}
                >
                    Use saved card
                </div>
            );
        } else if (savedCard) {
            savedCardAction = (
                <div
                    className="link-action saved-card-action"
                    onClick={this.props.stripeUseNewCard}
                >
                    Use different card
                </div>
            );
        }

        let billingInfoClass = classnames("billing-info", {
            "billing-info-empty": !billingInfo || !billingInfo.trim()
        });

        let billingInfoDisplay = (
            <div className={billingInfoClass}>
                <h5 className="billing-header">
                    Optional billing info{" "}
                    <ToolTip>
                        <p>
                            This information shows on your invoices, some people
                            need this for tax purposes. You can change it later.
                            It is great for VAT, Address, Job Number, Etc.
                        </p>
                    </ToolTip>
                </h5>
                <textarea
                    placeholder="VAT Numbers, Address, etc."
                    value={billingInfo || ""}
                    onChange={this.handleBillingInfoChange}
                />
            </div>
        );

        let purchaseDisclaimer, buyingSubscription;
        if (currentPurchase) {
            purchaseDisclaimer = (
                <p className="disclaimer">{currentPurchase.description}</p>
            );
        }

        let formClass = classnames("billing-form", {
            "with-stripe-error": !!error,
            "with-purchase-selected": !!currentPurchase
        });
        return (
            <div className={formClass}>
                <h3>Unlimited Pro Downloads</h3>
                <p>Over 1 Million Royalty–Free icons in any color & apps</p>
                <ul className="purchase-types purchase-types-subscriptions bubble-choices blue-choices">
                    {paymentOptions.subscriptions}
                </ul>
                <h3>Pay as you go</h3>
                <p>Get this icon Royalty–Free in any color</p>
                <ul className="purchase-types purchase-types-alacarte bubble-choices blue-choices">
                    {paymentOptions.alacarte}
                </ul>
                {dueNow}
                {purchaseDisclaimer}
                <div className="card-section">
                    <h5 className="billing-header">
                        Credit Card {saveCardInput}
                    </h5>
                    {cardDisplay}
                    {error}
                </div>
                {savedCardAction}
                {billingInfoDisplay}
                <button className={buttonClass} onClick={this.doDownload}>
                    Purchase {whatToPurchase}
                </button>
            </div>
        );
    }
}

const NounProInfo = props => {
    let apps = (
        <ul className="noun-pro-apps-list">
            <li>
                <img
                    src={require("../../../img/mac_app/apple@2x.png")}
                    alt="Noun Project for Mac"
                    title="Noun Project for Mac"
                    title="Drag and drop from your desktop."
                    width="18"
                    height="18"
                />
            </li>
            <li>
                <img
                    src={require("../../../img/for_windows/appicon_illustrator@2x.png")}
                    alt="Noun Project for Adobe Illustrator"
                    title="Noun Project for Adobe Illustrator"
                    width="18"
                    height="18"
                />
            </li>
            <li>
                <img
                    src={require("../../../img/for_windows/appicon_photoshop@2x.png")}
                    alt="Noun Project for Adobe Photoshop"
                    title="Noun Project for Adobe Photoshop"
                    width="18"
                    height="18"
                />
            </li>
            <li>
                <img
                    src={require("../../../img/for_windows/appicon_indesign@2x.png")}
                    alt="Noun Project for Adobe InDesign"
                    title="Noun Project for Adobe InDesign"
                    width="18"
                    height="18"
                />
            </li>
            <li>
                <img
                    src={require("../../../img/for_windows/logo_slides_128px.png")}
                    alt="Noun Project for Google Slides"
                    title="Noun Project for Google Slides"
                    width="18"
                    height="18"
                />
            </li>
            <li>
                <img
                    src={require("../../../img/for_windows/logo_docs_128px.png")}
                    alt="Noun Project for Google Docs"
                    title="Noun Project for Google Docs"
                    width="18"
                    height="18"
                />
            </li>
            <li>
                <img
                    src={require("../../../img/for_windows/Microsoft_PowerPoint_2013_logo.svg")}
                    alt="Noun Project for Microsoft PowerPoint"
                    title="Noun Project for Microsoft PowerPoint"
                    width="18"
                    height="18"
                />
            </li>
            <li>
                <img
                    src={require("../../../img/for_windows/Microsoft_Word_2013_logo.svg")}
                    alt="Noun Project for Microsoft Word"
                    title="Noun Project for Microsoft word"
                    width="18"
                    height="18"
                />
            </li>
        </ul>
    );
    return (
        <div className="noun-pro-info-section">
            <p>
                <a
                    href="/accounts/upgrade"
                    target="_blank"
                    className="pro-blue"
                >
                    NounPro Subscriptions
                </a>
                <br />
                include apps for
            </p>
            {apps}
            {props.children}
        </div>
    );
};

function mapStateToProps(state, ownProps) {
    let { stripe, user, download } = state;

    let { stripe: stripePublishableKey } = user;
    let { processing } = download;
    let {
        purchaseTypes,
        currentPurchase,
        error,
        saveCard,
        savedCard,
        useNewCard,
        showBillingInfo,
        billingInfo
    } = stripe;

    return {
        processing,
        purchaseTypes,
        currentPurchase,
        stripeError: error,
        saveCard,
        savedCard,
        useNewCard,
        user,
        showBillingInfo,
        billingInfo,
        stripePublishableKey
    };
}

export default connect(
    mapStateToProps,
    {
        downloadSelectPurchaseType: actions.downloadSelectPurchaseType,
        downloadPurchase: actions.downloadPurchase,
        stripeCardInputError: actions.stripeCardInputError,
        stripeCardInputChange: actions.stripeCardInputChange,
        stripeSaveCardChange: actions.stripeSaveCardChange,
        stripeGetSavedCard: actions.stripeGetSavedCard,
        stripeUseNewCard: actions.stripeUseNewCard,
        stripeUpdateBillingInfo: actions.stripeUpdateBillingInfo
    }
)(IconPaymentForm);
